module.exports = __webpack_public_path__ + "img/logo02.ab14a3cf.png";